
export default function Features() {
  const features = [
    {
      icon: "ri-file-list-3-line",
      title: "Cálculo de Rescisão",
      description: "Rescisões com ou sem justa causa, acordos e término de contrato"
    },
    {
      icon: "ri-time-line",
      title: "Cálculo de Pontos",
      description: "Horas Extras, horas noturnas, horas não trabalhadas"
    },
    {
      icon: "ri-file-text-line",
      title: "Gerador de Recibos Avulsos",
      description: "Simples, rápido e prático, exportação em PDF, podendo personalizar com sua logo"
    },
    {
      icon: "ri-calculator-line",
      title: "Calculadora de INSS/IRRF",
      description: "Tabelas 2026 atualizadas, cálculos para empregados e pró-laobre."
    },
    {
      icon: "ri-mail-line",
      title: "Caixa Postal do DP",
      description: "Notícias mais importantes e atualizadas, materiais e comunicados"
    },
    {
      icon: "ri-table-line",
      title: "Tabela de Rubricas",
      description: "288 rubricas cadastradas, com códigos de incidência de INSS, FGTS e IRRF"
    }
  ];

  return (
    <section id="recursos" className="py-20 md:py-32 px-4 bg-gradient-to-br from-gray-50 to-white">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-6">
            O sistema faz <span className="text-teal-600">tudo pra você</span>,<br />
            em instantes
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Todas as funcionalidades que você precisa para automatizar 
            seus cálculos trabalhistas com precisão total.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-2 border border-gray-100"
            >
              <div className="text-center">
                <div className="bg-teal-100 p-4 rounded-full inline-flex mb-6">
                  <i className={`${feature.icon} text-3xl text-teal-600`}></i>
                </div>
                <h3 className="text-xl font-bold mb-4 text-gray-900">{feature.title}</h3>
                <p className="text-gray-600 leading-relaxed">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Processo em 3 passos */}
        <div className="bg-gradient-to-r from-teal-600 to-cyan-600 rounded-3xl p-8 md:p-12 text-white">
          <h3 className="text-3xl md:text-4xl font-bold text-center mb-12">
            Em <span className="bg-yellow-400 text-gray-900 px-4 py-2 rounded-lg">3 passos</span>, 
            você tem cálculos prontos
          </h3>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="bg-white text-teal-600 rounded-full w-16 h-16 flex items-center justify-center text-2xl font-bold mx-auto mb-6">
                1
              </div>
              <h4 className="text-xl font-bold mb-4">Acesse o Sistema</h4>
              <p className="text-white/90">
                <a href="https://calculadp.tiagonogueira.com.br/ponto" target="_blank" rel="noopener noreferrer" className="hover:underline">
                  Faça login na plataforma de qualquer dispositivo
                </a>
              </p>
            </div>

            <div className="text-center">
              <div className="bg-white text-teal-600 rounded-full w-16 h-16 flex items-center justify-center text-2xl font-bold mx-auto mb-6">
                2
              </div>
              <h4 className="text-xl font-bold mb-4">Preencha os Dados</h4>
              <p className="text-white/90">Digite as informações do ponto ou rescisão</p>
            </div>

            <div className="text-center">
              <div className="bg-white text-teal-600 rounded-full w-16 h-16 flex items-center justify-center text-2xl font-bold mx-auto mb-6">
                3
              </div>
              <h4 className="text-xl font-bold mb-4">Gere o Relatório</h4>
              <p className="text-white/90">Baixe o PDF completo e compartilhe com o cliente</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
